export const BASE_URL = process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : '/';
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_DOMAIN ? process.env.REACT_APP_PUBLIC_DOMAIN : '/';
export const REGISTER_URL = process.env.REACT_APP_REGISTER_URL ? process.env.REACT_APP_REGISTER_URL : 'https://kuzgosweb-adm.kemobl.ru/register';
